import { createAsyncLocalStorage } from './async-local-storage';
export const workAsyncStorage = createAsyncLocalStorage();

//# sourceMappingURL=work-async-storage-instance.js.map